/** @jsxImportSource theme-ui */
import { useNavigate } from 'react-router-dom';
import { Box, Flex, Text } from 'theme-ui';

export const NEW_ITEMS_PINNING_PATH = '/collections/new-items-pinning';

// A "smart" (rule-based) collection: New Items is auto-populated by the 60-day new-item rule rather
// than hand-curated like a manual collection. It is always present on the Collections page and
// called out; the studio lets a user pin/promote items within it, per market. Click to drill into
// the pinning editor.
export default function NewItemsCollectionCallout() {
  const navigate = useNavigate();
  const open = () => navigate(NEW_ITEMS_PINNING_PATH);

  return (
    <Flex
      role="button"
      tabIndex={0}
      onClick={open}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') open();
      }}
      sx={{
        gap: 3,
        p: 3,
        mt: 3,
        mb: 3,
        alignItems: 'center',
        // Called-out styling: brand-yellow accent tint + left bar set it apart from the tabbed
        // collection lists, using theme tokens rather than one-off hex values.
        bg: 'primaryHighlight',
        border: '1px solid',
        borderColor: 'primaryPressed',
        borderLeft: '4px solid',
        borderLeftColor: 'primaryDefault',
        borderRadius: 1,
        cursor: 'pointer',
        transition: 'box-shadow 120ms',
        '&:hover': { boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Flex sx={{ gap: 2, alignItems: 'center' }}>
          <Text variant="paragraphBoldMd">New Items</Text>
          <Text
            variant="labelCapsSm"
            sx={{
              color: 'secondaryDefault',
              bg: 'neutralLight',
              border: '1px solid',
              borderColor: 'secondaryDisabled',
              borderRadius: 1,
              px: 2,
              py: '1px',
            }}
          >
            Smart collection
          </Text>
        </Flex>
        <Text
          variant="paragraphSm"
          sx={{ color: 'secondaryText', display: 'block', mt: 1 }}
        >
          Pin and promote items within this collection, per market.
        </Text>
      </Box>
      <Text
        variant="labelMd"
        sx={{
          color: 'secondaryDefault',
          fontWeight: 'bold',
          flexShrink: 0,
        }}
      >
        Manage →
      </Text>
    </Flex>
  );
}
